module.exports = __webpack_public_path__ + "assets/lithium-ion-battery.f0b2a734.svg";